<div class="skeleton-container">
  <div class="skeleton-sidebar">
    <div class="skeleton-sidebar-item"></div>
    <div class="skeleton-sidebar-item"></div>
    <div class="skeleton-sidebar-item"></div>
    <div class="skeleton-sidebar-item"></div>
  </div>
  <div class="skeleton-content">
    <div class="skeleton-header"></div>
    <div class="skeleton-table">
      <div class="skeleton-row">
        <div class="skeleton-cell"></div>
        <div class="skeleton-cell"></div>
        <div class="skeleton-cell"></div>
      </div>
      <div class="skeleton-row">
        <div class="skeleton-cell"></div>
        <div class="skeleton-cell"></div>
        <div class="skeleton-cell"></div>
      </div>
      <div class="skeleton-row">
        <div class="skeleton-cell"></div>
        <div class="skeleton-cell"></div>
        <div class="skeleton-cell"></div>
      </div>
    </div>
  </div>
</div>
